"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Switches the language and gets the new URL
 * @param {String} setLang
 * @returns {String}
 */
function switchLanguagePath(newLang) {
  var newPath = '';
  var currentPath = window.location.pathname; // eg. /ar/todos
  var currentQuery = window.location.search; // "" if no query present

  var regEx = /^\/[A-Z]{2}\//i; // looks for /en/ or /ar/ in the path
  if (regEx.test(currentPath)) {
    newPath = currentPath.replace(regEx, "/".concat(newLang, "/"));
  } else {
    var arr = currentPath.split('/');
    newPath = "/".concat(newLang).concat(currentPath);
    if (!arr[2] && arr[1].length === 2) {
      // eg. /en or /ar - root path
      newPath = "/".concat(newLang);
    }
  }
  return "".concat(window.location.origin).concat(newPath).concat(currentQuery);
}
var _default = exports["default"] = switchLanguagePath;